import { render, staticRenderFns } from "./sleep.vue?vue&type=template&id=605a029b&scoped=true&"
import script from "./sleep.vue?vue&type=script&lang=js&"
export * from "./sleep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a029b",
  null
  
)

export default component.exports